import { setIotData } from "../redux/BuildingSlice";

export function executeLinksCalls(dispatch, iotCalls) {
  for (const iot in iotCalls) {
    executeLinkCall(iotCalls[iot])
      .then((data) => {
        dispatch(setIotData({ data, iot }));
      })
      .catch((e) => console.log(e));
  }
}

function executeLinkCall(sitemap) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const { url } = sitemap;

    httpRequest.open("GET", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send();
    httpRequest.onreadystatechange = function () {
      if (this.status === 200) {
        if (this.readyState === 4) {
          const result = JSON.parse(httpRequest.responseText);
          resolve(result.map((e) => ({ ...e, id: e.channelUID })));
        }
      } else {
        reject(this.status);
      }
    };
  });
}

export function executeLinkCreate(sitemap, data) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const url = `${sitemap.url}/${data.itemName}/${encodeURIComponent(data.channelUID)}`;

    httpRequest.open("PUT", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send(JSON.stringify(data));
    httpRequest.onreadystatechange = function () {
      if (this.status === 200 || this.status === 201) {
        if (this.readyState === 4) {
          resolve(httpRequest.responseText);
        }
      } else {
        reject(httpRequest.responseText);
      }
    };
  });
}

export function executeLinkDelete(sitemap, data) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const url = `${sitemap.url}/${data.itemName}/${encodeURIComponent(data.channelUID)}`;

    httpRequest.open("DELETE", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send(JSON.stringify(data));
    httpRequest.onreadystatechange = function () {
      if (this.status === 200 || this.status === 201) {
        if (this.readyState === 4) {
          resolve(httpRequest.responseText);
        }
      } else {
        reject(httpRequest.status);
      }
    };
  });
}